var map = {
	"./modals/prepaid-services/prepaid-services.module": [
		"../../../../../src/app/modals/prepaid-services/prepaid-services.module.ts"
	],
	"./modules-for-lazyloading/administration/add-new-school-term.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/add-new-school-term.module.ts",
		"add-new-school-term.module"
	],
	"./modules-for-lazyloading/administration/add-update-branch.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/add-update-branch.module.ts",
		"add-update-branch.module"
	],
	"./modules-for-lazyloading/administration/administration.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/administration.module.ts",
		"administration.module"
	],
	"./modules-for-lazyloading/administration/approver-signature.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/approver-signature.module.ts",
		"approver-signature.module"
	],
	"./modules-for-lazyloading/administration/backend-service-settings.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/backend-service-settings.module.ts",
		"backend-service-settings.module"
	],
	"./modules-for-lazyloading/administration/bulk-pdf-status.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/bulk-pdf-status.module.ts",
		"bulk-pdf-status.module"
	],
	"./modules-for-lazyloading/administration/buy-sms.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/buy-sms.module.ts",
		"buy-sms.module"
	],
	"./modules-for-lazyloading/administration/canteen-menu.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/canteen-menu.module.ts",
		"common",
		"canteen-menu.module"
	],
	"./modules-for-lazyloading/administration/canteen.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/canteen.module.ts",
		"common",
		"canteen.module"
	],
	"./modules-for-lazyloading/administration/create-organization.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/create-organization.module.ts",
		"create-organization.module"
	],
	"./modules-for-lazyloading/administration/create-pickup-dropoff-person.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/create-pickup-dropoff-person.module.ts",
		"create-pickup-dropoff-person.module"
	],
	"./modules-for-lazyloading/administration/create-school.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/create-school.module.ts",
		"common",
		"create-school.module"
	],
	"./modules-for-lazyloading/administration/employee-account-status.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/employee-account-status.module.ts",
		"employee-account-status.module"
	],
	"./modules-for-lazyloading/administration/grading-scale.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/grading-scale.module.ts",
		"grading-scale.module"
	],
	"./modules-for-lazyloading/administration/guided-mode.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/guided-mode.module.ts",
		"guided-mode.module"
	],
	"./modules-for-lazyloading/administration/incident-management.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/incident-management.module.ts",
		"common",
		"incident-management.module"
	],
	"./modules-for-lazyloading/administration/notification-settings.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/notification-settings.module.ts",
		"notification-settings.module"
	],
	"./modules-for-lazyloading/administration/request-support.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/request-support.module.ts",
		"request-support.module"
	],
	"./modules-for-lazyloading/administration/review-approver-signature.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/review-approver-signature.module.ts",
		"review-approver-signature.module"
	],
	"./modules-for-lazyloading/administration/review-organization.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/review-organization.module.ts",
		"review-organization.module"
	],
	"./modules-for-lazyloading/administration/review-school-branch.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/review-school-branch.module.ts",
		"review-school-branch.module"
	],
	"./modules-for-lazyloading/administration/review-school-groups.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/review-school-groups.module.ts",
		"common",
		"review-school-groups.module"
	],
	"./modules-for-lazyloading/administration/school-calendar.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-calendar.module.ts",
		"common",
		"school-calendar.module"
	],
	"./modules-for-lazyloading/administration/school-daily-activity.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-daily-activity.module.ts",
		"common",
		"school-daily-activity.module"
	],
	"./modules-for-lazyloading/administration/school-daily-attendance-summary.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-daily-attendance-summary.module.ts",
		"common",
		"school-daily-attendance-summary.module"
	],
	"./modules-for-lazyloading/administration/school-duty-rooster.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-duty-rooster.module.ts",
		"school-duty-rooster.module"
	],
	"./modules-for-lazyloading/administration/school-message-template.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-message-template.module.ts",
		"school-message-template.module"
	],
	"./modules-for-lazyloading/administration/school-network-protection.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-network-protection.module.ts",
		"common",
		"school-network-protection.module"
	],
	"./modules-for-lazyloading/administration/school-notification-report.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-notification-report.module.ts",
		"common",
		"school-notification-report.module"
	],
	"./modules-for-lazyloading/administration/school-term-review.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-term-review.module.ts",
		"common",
		"school-term-review.module"
	],
	"./modules-for-lazyloading/administration/school-vendors.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/school-vendors.module.ts",
		"common",
		"school-vendors.module"
	],
	"./modules-for-lazyloading/administration/setup-gbook.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/setup-gbook.module.ts",
		"common",
		"setup-gbook.module"
	],
	"./modules-for-lazyloading/administration/summary-canteen-review.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/summary-canteen-review.module.ts",
		"common",
		"summary-canteen-review.module"
	],
	"./modules-for-lazyloading/administration/switch-accounts.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/switch-accounts.module.ts",
		"switch-accounts.module"
	],
	"./modules-for-lazyloading/administration/update-school-profile.module": [
		"../../../../../src/app/modules-for-lazyloading/administration/update-school-profile.module.ts",
		"common",
		"update-school-profile.module"
	],
	"./modules-for-lazyloading/bulk-export/bulk-export.module": [
		"../../../../../src/app/modules-for-lazyloading/bulk-export/bulk-export.module.ts",
		"bulk-export.module"
	],
	"./modules-for-lazyloading/classroom/assign-student-group/assign-student-group.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/assign-student-group/assign-student-group.module.ts",
		"assign-student-group.module"
	],
	"./modules-for-lazyloading/classroom/attendance-summary/attendance-summary.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/attendance-summary/attendance-summary.module.ts",
		"common",
		"attendance-summary.module"
	],
	"./modules-for-lazyloading/classroom/class-performance-report/class-performance-report.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/class-performance-report/class-performance-report.module.ts",
		"common",
		"class-performance-report.module"
	],
	"./modules-for-lazyloading/classroom/classroom-notification-history/classroom-notification-history.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/classroom-notification-history/classroom-notification-history.module.ts",
		"common",
		"classroom-notification-history.module"
	],
	"./modules-for-lazyloading/classroom/classroom-notification/classroom-notification.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/classroom-notification/classroom-notification.module.ts",
		"classroom-notification.module"
	],
	"./modules-for-lazyloading/classroom/classroom-review/classroom-review.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/classroom-review/classroom-review.module.ts",
		"common",
		"classroom-review.module"
	],
	"./modules-for-lazyloading/classroom/classroom-schedule/classroom-schedule.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/classroom-schedule/classroom-schedule.module.ts",
		"common",
		"classroom-schedule.module"
	],
	"./modules-for-lazyloading/classroom/classroom.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/classroom.module.ts",
		"classroom.module"
	],
	"./modules-for-lazyloading/classroom/ges-scheme-of-learning/ges-scheme-of-learning.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/ges-scheme-of-learning/ges-scheme-of-learning.module.ts",
		"common",
		"ges-scheme-of-learning.module"
	],
	"./modules-for-lazyloading/classroom/grades-review/grades-review.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/grades-review/grades-review.module.ts",
		"common",
		"grades-review.module"
	],
	"./modules-for-lazyloading/classroom/ib-lesson-plan/ib-lesson-plan.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/ib-lesson-plan/ib-lesson-plan.module.ts",
		"common",
		"ib-lesson-plan.module"
	],
	"./modules-for-lazyloading/classroom/lesson-plan/lesson-plan.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/lesson-plan/lesson-plan.module.ts",
		"common",
		"lesson-plan.module"
	],
	"./modules-for-lazyloading/classroom/move-students-in-group/move-students-in-group.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/move-students-in-group/move-students-in-group.module.ts",
		"move-students-in-group.module"
	],
	"./modules-for-lazyloading/classroom/new-classroom-setup/new-classroom-setup.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/new-classroom-setup/new-classroom-setup.module.ts",
		"new-classroom-setup.module"
	],
	"./modules-for-lazyloading/classroom/raw-grade-recording/raw-grade-recording.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/raw-grade-recording/raw-grade-recording.module.ts",
		"common",
		"raw-grade-recording.module"
	],
	"./modules-for-lazyloading/classroom/student-active-inactive-reason/student-active-inactive-reason.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/student-active-inactive-reason/student-active-inactive-reason.module.ts",
		"student-active-inactive-reason.module"
	],
	"./modules-for-lazyloading/classroom/student-attendance/student-attendance.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/student-attendance/student-attendance.module.ts",
		"common",
		"student-attendance.module"
	],
	"./modules-for-lazyloading/classroom/students-by-classroom/students-by-classroom.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/students-by-classroom/students-by-classroom.module.ts",
		"common",
		"students-by-classroom.module"
	],
	"./modules-for-lazyloading/classroom/students-by-group/students-by-group.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/students-by-group/students-by-group.module.ts",
		"students-by-group.module"
	],
	"./modules-for-lazyloading/classroom/update-classroom/update-classroom.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/update-classroom/update-classroom.module.ts",
		"update-classroom.module"
	],
	"./modules-for-lazyloading/classroom/weekly-attendance/weekly-attendance.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/weekly-attendance/weekly-attendance.module.ts",
		"common",
		"weekly-attendance.module"
	],
	"./modules-for-lazyloading/classroom/weekly-work-plan/weekly-work-plan.module": [
		"../../../../../src/app/modules-for-lazyloading/classroom/weekly-work-plan/weekly-work-plan.module.ts",
		"common",
		"weekly-work-plan.module"
	],
	"./modules-for-lazyloading/courses/assign-course-category.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/assign-course-category.module.ts",
		"assign-course-category.module"
	],
	"./modules-for-lazyloading/courses/assign-student-course.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/assign-student-course.module.ts",
		"assign-student-course.module"
	],
	"./modules-for-lazyloading/courses/course-teacher-link.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/course-teacher-link.module.ts",
		"course-teacher-link.module"
	],
	"./modules-for-lazyloading/courses/courses.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/courses.module.ts",
		"courses.module"
	],
	"./modules-for-lazyloading/courses/move-students-from-course.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/move-students-from-course.module.ts",
		"move-students-from-course.module"
	],
	"./modules-for-lazyloading/courses/new-course.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/new-course.module.ts",
		"new-course.module"
	],
	"./modules-for-lazyloading/courses/show-available-courses.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/show-available-courses.module.ts",
		"common",
		"show-available-courses.module"
	],
	"./modules-for-lazyloading/courses/students-by-course.module": [
		"../../../../../src/app/modules-for-lazyloading/courses/students-by-course.module.ts",
		"common",
		"students-by-course.module"
	],
	"./modules-for-lazyloading/fileList/fileList.module": [
		"../../../../../src/app/modules-for-lazyloading/fileList/fileList.module.ts",
		"fileList.module"
	],
	"./modules-for-lazyloading/financial/accounts-payable-report/accounts-payable-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/accounts-payable-report/accounts-payable-report.module.ts",
		"common",
		"accounts-payable-report.module"
	],
	"./modules-for-lazyloading/financial/accounts-receivable-report/accounts-receivable-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/accounts-receivable-report/accounts-receivable-report.module.ts",
		"common",
		"accounts-receivable-report.module"
	],
	"./modules-for-lazyloading/financial/advancepaymentreport/advancepaymentreport.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/advancepaymentreport/advancepaymentreport.module.ts",
		"common",
		"advancepaymentreport.module"
	],
	"./modules-for-lazyloading/financial/baddebtreport/baddebtreport.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/baddebtreport/baddebtreport.module.ts",
		"common",
		"baddebtreport.module"
	],
	"./modules-for-lazyloading/financial/balance-sheet/balance-sheet.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/balance-sheet/balance-sheet.module.ts",
		"common",
		"balance-sheet.module"
	],
	"./modules-for-lazyloading/financial/bank-activity-report/bank-activity-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/bank-activity-report/bank-activity-report.module.ts",
		"bank-activity-report.module"
	],
	"./modules-for-lazyloading/financial/bill-item/bill-item.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/bill-item/bill-item.module.ts",
		"common",
		"bill-item.module"
	],
	"./modules-for-lazyloading/financial/bulk-billing/bulk-billing.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/bulk-billing/bulk-billing.module.ts",
		"bulk-billing.module"
	],
	"./modules-for-lazyloading/financial/bulk-edit-bills/bulk-edit-bill.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/bulk-edit-bills/bulk-edit-bill.module.ts",
		"common",
		"bulk-edit-bill.module"
	],
	"./modules-for-lazyloading/financial/bulk-pay-bill-item/bulk-pay-bill-item.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/bulk-pay-bill-item/bulk-pay-bill-item.module.ts",
		"common",
		"bulk-pay-bill-item.module"
	],
	"./modules-for-lazyloading/financial/cash-flow-statement/cash-flow-statement.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/cash-flow-statement/cash-flow-statement.module.ts",
		"common",
		"cash-flow-statement.module"
	],
	"./modules-for-lazyloading/financial/chart-of-accounts-balance/chart-of-accounts-balance.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/chart-of-accounts-balance/chart-of-accounts-balance.module.ts",
		"common",
		"chart-of-accounts-balance.module"
	],
	"./modules-for-lazyloading/financial/chart-of-accounts/chart-of-accounts.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/chart-of-accounts/chart-of-accounts.module.ts",
		"common",
		"chart-of-accounts.module"
	],
	"./modules-for-lazyloading/financial/create-new-invoice-bill.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/create-new-invoice-bill.module.ts",
		"create-new-invoice-bill.module"
	],
	"./modules-for-lazyloading/financial/create-selective-bill-invoice.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/create-selective-bill-invoice.module.ts",
		"create-selective-bill-invoice.module"
	],
	"./modules-for-lazyloading/financial/daily-fee-recon/daily-fee-recon.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/daily-fee-recon/daily-fee-recon.module.ts",
		"common",
		"daily-fee-recon.module"
	],
	"./modules-for-lazyloading/financial/daily-financial-summary-report/daily-financial-summary-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/daily-financial-summary-report/daily-financial-summary-report.module.ts",
		"common",
		"daily-financial-summary-report.module"
	],
	"./modules-for-lazyloading/financial/daily-transactional-report/daily-transactional-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/daily-transactional-report/daily-transactional-report.module.ts",
		"common",
		"daily-transactional-report.module"
	],
	"./modules-for-lazyloading/financial/depreciation-schedule/depreciation-schedule.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/depreciation-schedule/depreciation-schedule.module.ts",
		"common",
		"depreciation-schedule.module"
	],
	"./modules-for-lazyloading/financial/discount-report/discount-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/discount-report/discount-report.module.ts",
		"discount-report.module"
	],
	"./modules-for-lazyloading/financial/externalpaymentreport/externalpaymentreport.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/externalpaymentreport/externalpaymentreport.module.ts",
		"common",
		"externalpaymentreport.module"
	],
	"./modules-for-lazyloading/financial/financial-account-balance/financial-account-balance.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/financial-account-balance/financial-account-balance.module.ts",
		"common",
		"financial-account-balance.module"
	],
	"./modules-for-lazyloading/financial/financial-account-history/financial-account-history.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/financial-account-history/financial-account-history.module.ts",
		"common",
		"financial-account-history.module"
	],
	"./modules-for-lazyloading/financial/financialmanagement/financialmanagement.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/financialmanagement/financialmanagement.module.ts",
		"financialmanagement.module"
	],
	"./modules-for-lazyloading/financial/fixed-assets-report/fixed-assets-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/fixed-assets-report/fixed-assets-report.module.ts",
		"common",
		"fixed-assets-report.module"
	],
	"./modules-for-lazyloading/financial/funds-transfer-report/funds-transfer-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/funds-transfer-report/funds-transfer-report.module.ts",
		"common",
		"funds-transfer-report.module"
	],
	"./modules-for-lazyloading/financial/funds-transfer/funds-transfer.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/funds-transfer/funds-transfer.module.ts",
		"funds-transfer.module"
	],
	"./modules-for-lazyloading/financial/invoice-bill-age-report/invoice-bill-age-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/invoice-bill-age-report/invoice-bill-age-report.module.ts",
		"common",
		"invoice-bill-age-report.module"
	],
	"./modules-for-lazyloading/financial/invoice-bill-line-item-report/invoice-bill-line-item-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/invoice-bill-line-item-report/invoice-bill-line-item-report.module.ts",
		"common",
		"invoice-bill-line-item-report.module"
	],
	"./modules-for-lazyloading/financial/invoice-bill-report/invoice-bill-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/invoice-bill-report/invoice-bill-report.module.ts",
		"common",
		"invoice-bill-report.module"
	],
	"./modules-for-lazyloading/financial/line-item-on-demand-payment/line-item-on-demand-payment.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/line-item-on-demand-payment/line-item-on-demand-payment.module.ts",
		"line-item-on-demand-payment.module"
	],
	"./modules-for-lazyloading/financial/on-demand-payment/on-demand-payment.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/on-demand-payment/on-demand-payment.module.ts",
		"common",
		"on-demand-payment.module"
	],
	"./modules-for-lazyloading/financial/org-rev-report/org-rev-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/org-rev-report/org-rev-report.module.ts",
		"common",
		"org-rev-report.module"
	],
	"./modules-for-lazyloading/financial/pay-bill/pay-bill.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/pay-bill/pay-bill.module.ts",
		"common",
		"pay-bill.module"
	],
	"./modules-for-lazyloading/financial/pay-expense-report/pay-expense-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/pay-expense-report/pay-expense-report.module.ts",
		"common",
		"pay-expense-report.module"
	],
	"./modules-for-lazyloading/financial/payment-history-line-item-report/payment-history-line-item-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/payment-history-line-item-report/payment-history-line-item-report.module.ts",
		"common",
		"payment-history-line-item-report.module"
	],
	"./modules-for-lazyloading/financial/payment-history/payment-history.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/payment-history/payment-history.module.ts",
		"common",
		"payment-history.module"
	],
	"./modules-for-lazyloading/financial/profit-loss-statement/profit-loss-statement.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/profit-loss-statement/profit-loss-statement.module.ts",
		"common",
		"profit-loss-statement.module"
	],
	"./modules-for-lazyloading/financial/receive-revenue/receive-revenue.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/receive-revenue/receive-revenue.module.ts",
		"common",
		"receive-revenue.module"
	],
	"./modules-for-lazyloading/financial/record-expense/record-expense.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/record-expense/record-expense.module.ts",
		"record-expense.module"
	],
	"./modules-for-lazyloading/financial/record-revenue/record-revenue.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/record-revenue/record-revenue.module.ts",
		"record-revenue.module"
	],
	"./modules-for-lazyloading/financial/resend-payment-notification/resend-payment-notification.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/resend-payment-notification/resend-payment-notification.module.ts",
		"common",
		"resend-payment-notification.module"
	],
	"./modules-for-lazyloading/financial/review-school-invoice-items/review-school-invoice-items.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/review-school-invoice-items/review-school-invoice-items.module.ts",
		"common",
		"review-school-invoice-items.module"
	],
	"./modules-for-lazyloading/financial/school-expense-report/school-expense-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/school-expense-report/school-expense-report.module.ts",
		"common",
		"school-expense-report.module"
	],
	"./modules-for-lazyloading/financial/school-revenue-report/school-revenue-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/school-revenue-report/school-revenue-report.module.ts",
		"common",
		"school-revenue-report.module"
	],
	"./modules-for-lazyloading/financial/selective-bill/selective-bill.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/selective-bill/selective-bill.module.ts",
		"selective-bill.module"
	],
	"./modules-for-lazyloading/financial/selective-on-demand-payment/selective-on-demand-payment.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/selective-on-demand-payment/selective-on-demand-payment.module.ts",
		"common",
		"selective-on-demand-payment.module"
	],
	"./modules-for-lazyloading/financial/setup-student-invoice-items/setup-student-invoice-items.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/setup-student-invoice-items/setup-student-invoice-items.module.ts",
		"setup-student-invoice-items.module"
	],
	"./modules-for-lazyloading/financial/sims-dash/sims-dash.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/sims-dash/sims-dash.module.ts",
		"common",
		"sims-dash.module"
	],
	"./modules-for-lazyloading/financial/student-account/student-account.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/student-account/student-account.module.ts",
		"common",
		"student-account.module"
	],
	"./modules-for-lazyloading/financial/student-financial-statement/student-financial-statement.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/student-financial-statement/student-financial-statement.module.ts",
		"common",
		"student-financial-statement.module"
	],
	"./modules-for-lazyloading/financial/unbilled-student-report/unbilled-student-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/unbilled-student-report/unbilled-student-report.module.ts",
		"common",
		"unbilled-student-report.module"
	],
	"./modules-for-lazyloading/financial/update-expense/update-expense.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/update-expense/update-expense.module.ts",
		"update-expense.module"
	],
	"./modules-for-lazyloading/financial/voucher-report/voucher-report.module": [
		"../../../../../src/app/modules-for-lazyloading/financial/voucher-report/voucher-report.module.ts",
		"common",
		"voucher-report.module"
	],
	"./modules-for-lazyloading/home/home.module": [
		"../../../../../src/app/modules-for-lazyloading/home/home.module.ts",
		"common",
		"home.module"
	],
	"./modules-for-lazyloading/inventory/inventory-categories/inventory-categories.module": [
		"../../../../../src/app/modules-for-lazyloading/inventory/inventory-categories/inventory-categories.module.ts",
		"common",
		"inventory-categories.module"
	],
	"./modules-for-lazyloading/inventory/inventory-group/inventory-group.module": [
		"../../../../../src/app/modules-for-lazyloading/inventory/inventory-group/inventory-group.module.ts",
		"inventory-group.module"
	],
	"./modules-for-lazyloading/inventory/inventory-items-by-vendor/inventory-items-by-vendor.module": [
		"../../../../../src/app/modules-for-lazyloading/inventory/inventory-items-by-vendor/inventory-items-by-vendor.module.ts",
		"common",
		"inventory-items-by-vendor.module"
	],
	"./modules-for-lazyloading/inventory/inventory-items/inventory-items.module": [
		"../../../../../src/app/modules-for-lazyloading/inventory/inventory-items/inventory-items.module.ts",
		"common",
		"inventory-items.module"
	],
	"./modules-for-lazyloading/inventory/inventory-report/inventory-report.module": [
		"../../../../../src/app/modules-for-lazyloading/inventory/inventory-report/inventory-report.module.ts",
		"common",
		"inventory-report.module"
	],
	"./modules-for-lazyloading/inventory/inventory.module": [
		"../../../../../src/app/modules-for-lazyloading/inventory/inventory.module.ts",
		"inventory.module"
	],
	"./modules-for-lazyloading/non-academic/assessment-category-comments.module": [
		"../../../../../src/app/modules-for-lazyloading/non-academic/assessment-category-comments.module.ts",
		"common",
		"assessment-category-comments.module"
	],
	"./modules-for-lazyloading/non-academic/child-assessment-report.module": [
		"../../../../../src/app/modules-for-lazyloading/non-academic/child-assessment-report.module.ts",
		"common",
		"child-assessment-report.module"
	],
	"./modules-for-lazyloading/non-academic/development-assessment-rating.module": [
		"../../../../../src/app/modules-for-lazyloading/non-academic/development-assessment-rating.module.ts",
		"development-assessment-rating.module"
	],
	"./modules-for-lazyloading/non-academic/development-category.module": [
		"../../../../../src/app/modules-for-lazyloading/non-academic/development-category.module.ts",
		"development-category.module"
	],
	"./modules-for-lazyloading/non-academic/non-academic.module": [
		"../../../../../src/app/modules-for-lazyloading/non-academic/non-academic.module.ts",
		"non-academic.module"
	],
	"./modules-for-lazyloading/notifications/notifications.module": [
		"../../../../../src/app/modules-for-lazyloading/notifications/notifications.module.ts",
		"notifications.module"
	],
	"./modules-for-lazyloading/payroll/create-employee-payslip.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/create-employee-payslip.module.ts",
		"common",
		"create-employee-payslip.module"
	],
	"./modules-for-lazyloading/payroll/create-multiple-employee-payslip.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/create-multiple-employee-payslip.module.ts",
		"common",
		"create-multiple-employee-payslip.module"
	],
	"./modules-for-lazyloading/payroll/generate-payslip-pdf.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/generate-payslip-pdf.module.ts",
		"generate-payslip-pdf.module"
	],
	"./modules-for-lazyloading/payroll/my-payslips.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/my-payslips.module.ts",
		"common",
		"my-payslips.module"
	],
	"./modules-for-lazyloading/payroll/payroll-deduction-addition.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/payroll-deduction-addition.module.ts",
		"payroll-deduction-addition.module"
	],
	"./modules-for-lazyloading/payroll/payroll-payment.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/payroll-payment.module.ts",
		"common",
		"payroll-payment.module"
	],
	"./modules-for-lazyloading/payroll/payroll-report-export.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/payroll-report-export.module.ts",
		"payroll-report-export.module"
	],
	"./modules-for-lazyloading/payroll/payroll-summary-report.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/payroll-summary-report.module.ts",
		"common",
		"payroll-summary-report.module"
	],
	"./modules-for-lazyloading/payroll/payroll.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/payroll.module.ts",
		"payroll.module"
	],
	"./modules-for-lazyloading/payroll/record-employee-loan.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/record-employee-loan.module.ts",
		"record-employee-loan.module"
	],
	"./modules-for-lazyloading/payroll/review-employee-payroll.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/review-employee-payroll.module.ts",
		"common",
		"review-employee-payroll.module"
	],
	"./modules-for-lazyloading/payroll/setup-employee-loan-terms.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/setup-employee-loan-terms.module.ts",
		"common",
		"setup-employee-loan-terms.module"
	],
	"./modules-for-lazyloading/payroll/setup-employees-deduction-addition.module": [
		"../../../../../src/app/modules-for-lazyloading/payroll/setup-employees-deduction-addition.module.ts",
		"common",
		"setup-employees-deduction-addition.module"
	],
	"./modules-for-lazyloading/report/assessment-report-comment.module": [
		"../../../../../src/app/modules-for-lazyloading/report/assessment-report-comment.module.ts",
		"assessment-report-comment.module"
	],
	"./modules-for-lazyloading/report/auto-generate-final-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/auto-generate-final-report.module.ts",
		"auto-generate-final-report.module"
	],
	"./modules-for-lazyloading/report/bece-forecaster.module": [
		"../../../../../src/app/modules-for-lazyloading/report/bece-forecaster.module.ts",
		"bece-forecaster.module"
	],
	"./modules-for-lazyloading/report/child-development-analysis.module": [
		"../../../../../src/app/modules-for-lazyloading/report/child-development-analysis.module.ts",
		"common",
		"child-development-analysis.module"
	],
	"./modules-for-lazyloading/report/child-development-assessment.module": [
		"../../../../../src/app/modules-for-lazyloading/report/child-development-assessment.module.ts",
		"common",
		"child-development-assessment.module"
	],
	"./modules-for-lazyloading/report/class-development-assessment.module": [
		"../../../../../src/app/modules-for-lazyloading/report/class-development-assessment.module.ts",
		"common",
		"class-development-assessment.module"
	],
	"./modules-for-lazyloading/report/detail-progress-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/detail-progress-report.module.ts",
		"common",
		"detail-progress-report.module"
	],
	"./modules-for-lazyloading/report/export-annual-final-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/export-annual-final-report.module.ts",
		"common",
		"export-annual-final-report.module"
	],
	"./modules-for-lazyloading/report/export-progress-report-pdf.module": [
		"../../../../../src/app/modules-for-lazyloading/report/export-progress-report-pdf.module.ts",
		"export-progress-report-pdf.module"
	],
	"./modules-for-lazyloading/report/external-examination-results.module": [
		"../../../../../src/app/modules-for-lazyloading/report/external-examination-results.module.ts",
		"external-examination-results.module"
	],
	"./modules-for-lazyloading/report/final-marks-review.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-marks-review.module.ts",
		"common",
		"final-marks-review.module"
	],
	"./modules-for-lazyloading/report/final-report-analysis.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report-analysis.module.ts",
		"common",
		"final-report-analysis.module"
	],
	"./modules-for-lazyloading/report/final-report-comment.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report-comment.module.ts",
		"final-report-comment.module"
	],
	"./modules-for-lazyloading/report/final-report-gpa.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report-gpa.module.ts",
		"common",
		"final-report-gpa.module"
	],
	"./modules-for-lazyloading/report/final-report-quality-check.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report-quality-check.module.ts",
		"common",
		"final-report-quality-check.module"
	],
	"./modules-for-lazyloading/report/final-report-status.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report-status.module.ts",
		"common",
		"final-report-status.module"
	],
	"./modules-for-lazyloading/report/final-report-subject-position.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report-subject-position.module.ts",
		"common",
		"final-report-subject-position.module"
	],
	"./modules-for-lazyloading/report/final-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/final-report.module.ts",
		"final-report.module"
	],
	"./modules-for-lazyloading/report/generate-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/generate-report.module.ts",
		"common",
		"generate-report.module"
	],
	"./modules-for-lazyloading/report/manual-final-mark-entry.module": [
		"../../../../../src/app/modules-for-lazyloading/report/manual-final-mark-entry.module.ts",
		"common",
		"manual-final-mark-entry.module"
	],
	"./modules-for-lazyloading/report/progress-report-subject-position.module": [
		"../../../../../src/app/modules-for-lazyloading/report/progress-report-subject-position.module.ts",
		"common",
		"progress-report-subject-position.module"
	],
	"./modules-for-lazyloading/report/progress-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/progress-report.module.ts",
		"progress-report.module"
	],
	"./modules-for-lazyloading/report/report-status.module": [
		"../../../../../src/app/modules-for-lazyloading/report/report-status.module.ts",
		"common",
		"report-status.module"
	],
	"./modules-for-lazyloading/report/report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/report.module.ts",
		"report.module"
	],
	"./modules-for-lazyloading/report/review-class-progress-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/review-class-progress-report.module.ts",
		"common",
		"review-class-progress-report.module"
	],
	"./modules-for-lazyloading/report/review-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/review-report.module.ts",
		"common",
		"review-report.module"
	],
	"./modules-for-lazyloading/report/send-final-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/send-final-report.module.ts",
		"send-final-report.module"
	],
	"./modules-for-lazyloading/report/send-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/send-report.module.ts",
		"send-report.module"
	],
	"./modules-for-lazyloading/report/student-award.module": [
		"../../../../../src/app/modules-for-lazyloading/report/student-award.module.ts",
		"common",
		"student-award.module"
	],
	"./modules-for-lazyloading/report/student-final-report-review.module": [
		"../../../../../src/app/modules-for-lazyloading/report/student-final-report-review.module.ts",
		"common",
		"student-final-report-review.module"
	],
	"./modules-for-lazyloading/report/student-promotion.module": [
		"../../../../../src/app/modules-for-lazyloading/report/student-promotion.module.ts",
		"student-promotion.module"
	],
	"./modules-for-lazyloading/report/view-final-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/view-final-report.module.ts",
		"common",
		"view-final-report.module"
	],
	"./modules-for-lazyloading/report/view-report.module": [
		"../../../../../src/app/modules-for-lazyloading/report/view-report.module.ts",
		"common",
		"view-report.module"
	],
	"./modules-for-lazyloading/settings/academic-report-setup.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/academic-report-setup.module.ts",
		"academic-report-setup.module"
	],
	"./modules-for-lazyloading/settings/bulk-data-upload-report.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/bulk-data-upload-report.module.ts",
		"bulk-data-upload-report.module"
	],
	"./modules-for-lazyloading/settings/bulk-enroll.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/bulk-enroll.module.ts",
		"bulk-enroll.module"
	],
	"./modules-for-lazyloading/settings/employee-evaluation-setup.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/employee-evaluation-setup.module.ts",
		"common",
		"employee-evaluation-setup.module"
	],
	"./modules-for-lazyloading/settings/final-report-template-setup.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/final-report-template-setup.module.ts",
		"final-report-template-setup.module"
	],
	"./modules-for-lazyloading/settings/settings.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/settings.module.ts",
		"settings.module"
	],
	"./modules-for-lazyloading/settings/ui-setup.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/ui-setup.module.ts",
		"ui-setup.module"
	],
	"./modules-for-lazyloading/settings/user-roles.module": [
		"../../../../../src/app/modules-for-lazyloading/settings/user-roles.module.ts",
		"common",
		"user-roles.module"
	],
	"./modules-for-lazyloading/staff-teacher/bulk-employee-attendance/bulk-employee-attendance.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/bulk-employee-attendance/bulk-employee-attendance.module.ts",
		"common",
		"bulk-employee-attendance.module"
	],
	"./modules-for-lazyloading/staff-teacher/employee-assessment/employee-assessment.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/employee-assessment/employee-assessment.module.ts",
		"common",
		"employee-assessment.module"
	],
	"./modules-for-lazyloading/staff-teacher/employee-attendance/employee-attendance.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/employee-attendance/employee-attendance.module.ts",
		"common",
		"employee-attendance.module"
	],
	"./modules-for-lazyloading/staff-teacher/employee-dashboard/employee-dashboard.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/employee-dashboard/employee-dashboard.module.ts",
		"employee-dashboard.module"
	],
	"./modules-for-lazyloading/staff-teacher/employee-performance/employee-performance.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/employee-performance/employee-performance.module.ts",
		"common",
		"employee-performance.module"
	],
	"./modules-for-lazyloading/staff-teacher/employee-setup/employee-setup.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/employee-setup/employee-setup.module.ts",
		"common",
		"employee-setup.module"
	],
	"./modules-for-lazyloading/staff-teacher/manage-timeoff/employee-timeoff.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/manage-timeoff/employee-timeoff.module.ts",
		"common",
		"employee-timeoff.module"
	],
	"./modules-for-lazyloading/staff-teacher/move-staff-teacher-in-group/move-staff-teacher-in-group.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/move-staff-teacher-in-group/move-staff-teacher-in-group.module.ts",
		"move-staff-teacher-in-group.module"
	],
	"./modules-for-lazyloading/staff-teacher/review-employee-assessment/review-employee-assessment.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/review-employee-assessment/review-employee-assessment.module.ts",
		"common",
		"review-employee-assessment.module"
	],
	"./modules-for-lazyloading/staff-teacher/search-employee/search-employee.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/search-employee/search-employee.module.ts",
		"search-employee.module"
	],
	"./modules-for-lazyloading/staff-teacher/staff-notice/staff-notice.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/staff-notice/staff-notice.module.ts",
		"staff-notice.module"
	],
	"./modules-for-lazyloading/staff-teacher/staff-teacher-by-group/staff-teacher-by-group.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/staff-teacher-by-group/staff-teacher-by-group.module.ts",
		"staff-teacher-by-group.module"
	],
	"./modules-for-lazyloading/staff-teacher/staff-teacher.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/staff-teacher.module.ts",
		"staff-teacher.module"
	],
	"./modules-for-lazyloading/staff-teacher/update-employee-profile/update-employee-profile.module": [
		"../../../../../src/app/modules-for-lazyloading/staff-teacher/update-employee-profile/update-employee-profile.module.ts",
		"common",
		"update-employee-profile.module"
	],
	"./modules-for-lazyloading/student/enroll-student.module": [
		"../../../../../src/app/modules-for-lazyloading/student/enroll-student.module.ts",
		"common",
		"enroll-student.module"
	],
	"./modules-for-lazyloading/student/ges-student-transcript.module": [
		"../../../../../src/app/modules-for-lazyloading/student/ges-student-transcript.module.ts",
		"common",
		"ges-student-transcript.module"
	],
	"./modules-for-lazyloading/student/household-report.module": [
		"../../../../../src/app/modules-for-lazyloading/student/household-report.module.ts",
		"common",
		"household-report.module"
	],
	"./modules-for-lazyloading/student/igcse-student-transcript.module": [
		"../../../../../src/app/modules-for-lazyloading/student/igcse-student-transcript.module.ts",
		"igcse-student-transcript.module"
	],
	"./modules-for-lazyloading/student/move-student.module": [
		"../../../../../src/app/modules-for-lazyloading/student/move-student.module.ts",
		"move-student.module"
	],
	"./modules-for-lazyloading/student/pick-up-drop-off-log.module": [
		"../../../../../src/app/modules-for-lazyloading/student/pick-up-drop-off-log.module.ts",
		"common",
		"pick-up-drop-off-log.module"
	],
	"./modules-for-lazyloading/student/pick-up-drop-off.module": [
		"../../../../../src/app/modules-for-lazyloading/student/pick-up-drop-off.module.ts",
		"common",
		"pick-up-drop-off.module"
	],
	"./modules-for-lazyloading/student/review-student-award.module": [
		"../../../../../src/app/modules-for-lazyloading/student/review-student-award.module.ts",
		"review-student-award.module"
	],
	"./modules-for-lazyloading/student/review-student-daily-activity.module": [
		"../../../../../src/app/modules-for-lazyloading/student/review-student-daily-activity.module.ts",
		"common",
		"review-student-daily-activity.module"
	],
	"./modules-for-lazyloading/student/school-boarding-house.module": [
		"../../../../../src/app/modules-for-lazyloading/student/school-boarding-house.module.ts",
		"school-boarding-house.module"
	],
	"./modules-for-lazyloading/student/search-inactive-students.module": [
		"../../../../../src/app/modules-for-lazyloading/student/search-inactive-students.module.ts",
		"common",
		"search-inactive-students.module"
	],
	"./modules-for-lazyloading/student/search-student.module": [
		"../../../../../src/app/modules-for-lazyloading/student/search-student.module.ts",
		"search-student.module"
	],
	"./modules-for-lazyloading/student/setup-dropoff-balance-check.module": [
		"../../../../../src/app/modules-for-lazyloading/student/setup-dropoff-balance-check.module.ts",
		"setup-dropoff-balance-check.module"
	],
	"./modules-for-lazyloading/student/student-admission-report.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-admission-report.module.ts",
		"common",
		"student-admission-report.module"
	],
	"./modules-for-lazyloading/student/student-behavior-review.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-behavior-review.module.ts",
		"student-behavior-review.module"
	],
	"./modules-for-lazyloading/student/student-behavior.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-behavior.module.ts",
		"student-behavior.module"
	],
	"./modules-for-lazyloading/student/student-birthday-report.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-birthday-report.module.ts",
		"common",
		"student-birthday-report.module"
	],
	"./modules-for-lazyloading/student/student-medical-history.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-medical-history.module.ts",
		"common",
		"student-medical-history.module"
	],
	"./modules-for-lazyloading/student/student-mini-profile.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-mini-profile.module.ts",
		"student-mini-profile.module"
	],
	"./modules-for-lazyloading/student/student-notification-history.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-notification-history.module.ts",
		"common",
		"student-notification-history.module"
	],
	"./modules-for-lazyloading/student/student-population.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-population.module.ts",
		"common",
		"student-population.module"
	],
	"./modules-for-lazyloading/student/student-transcript-status.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student-transcript-status.module.ts",
		"student-transcript-status.module"
	],
	"./modules-for-lazyloading/student/student.module": [
		"../../../../../src/app/modules-for-lazyloading/student/student.module.ts",
		"student.module"
	],
	"./modules-for-lazyloading/student/update-student-profile.module": [
		"../../../../../src/app/modules-for-lazyloading/student/update-student-profile.module.ts",
		"common",
		"update-student-profile.module"
	],
	"./modules-for-lazyloading/upload/upload.module": [
		"../../../../../src/app/modules-for-lazyloading/upload/upload.module.ts",
		"common",
		"upload.module"
	],
	"./modules-for-lazyloading/upload/whats-new.module": [
		"../../../../../src/app/modules-for-lazyloading/upload/whats-new.module.ts",
		"whats-new.module"
	],
	"./pages/report/report-calculation/report-calculation.module": [
		"../../../../../src/app/pages/report/report-calculation/report-calculation.module.ts",
		"report-calculation.module"
	],
	"app/session/session.module": [
		"../../../../../src/app/session/session.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main